import { useEffect, useState } from "react";
import API from "../../../services/api";
import "./assignStudentMess.css";

export default function AssignStudentMess() {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));

  const [hostels, setHostels] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [students, setStudents] = useState([]);
  const [plans, setPlans] = useState([]);

  const [hostel, setHostel] = useState("");
  const [room, setRoom] = useState("");
  const [student, setStudent] = useState("");
  const [plan, setPlan] = useState("");
  const [foodType, setFoodType] = useState("veg");

  useEffect(() => {
    loadHostels();
  }, []);

  const loadHostels = async () => {
    const res = await API.get("/school-admin/hostels/", {
      headers: { "X-SCHOOL-ID": school.school.id },
    });
    setHostels(res.data.hostels || []);
  };

  const loadRooms = async (hostelId) => {
    const res = await API.get(`/school-admin/hostels/${hostelId}/rooms/`, {
      headers: { "X-SCHOOL-ID": school.school.id },
    });
    setRooms(res.data.rooms || []);
  };

  const loadStudents = async (roomId) => {
    const res = await API.get(`/school-admin/rooms/${roomId}/students/`, {
      headers: { "X-SCHOOL-ID": school.school.id },
    });
    setStudents(res.data.students || []);
  };

  const loadPlans = async (hostelId) => {
    const res = await API.get("/school-admin/hostel/mess/plans/", {
      headers: { "X-SCHOOL-ID": school.school.id },
    });

    setPlans(
      (res.data.plans || []).filter(
        (p) => p.hostel_id === Number(hostelId) && p.is_active
      )
    );
  };

  const assign = async () => {
    if (!hostel || !room || !student || !plan) {
      alert("⚠️ Please select all fields");
      return;
    }

    await API.post(
      "/school-admin/hostel/mess/assign/",
      {
        hostel: Number(hostel),
        room: Number(room),
        student: Number(student),
        mess_plan: Number(plan),
        food_type: foodType,
      },
      { headers: { "X-SCHOOL-ID": school.school.id } }
    );

    alert("✅ Student assigned to mess successfully");
    setStudent("");
    setFoodType("veg");
  };

  return (
    <div className="mess-assign-page">
      <h2>🍛 Assign Student to Mess</h2>

      <div className="mess-assign-card">
        <select
          value={hostel}
          onChange={(e) => {
            const id = e.target.value;
            setHostel(id);
            setRoom("");
            setStudent("");
            setRooms([]);
            setStudents([]);
            setPlans([]);
            if (id) {
              loadRooms(id);
              loadPlans(id);
            }
          }}
        >
          <option value="">Select Hostel</option>
          {hostels.map((h) => (
            <option key={h.id} value={h.id}>{h.name}</option>
          ))}
        </select>

        <select
          value={room}
          disabled={!hostel}
          onChange={(e) => {
            const id = e.target.value;
            setRoom(id);
            setStudent("");
            if (id) loadStudents(id);
          }}
        >
          <option value="">Select Room</option>
          {rooms.map((r) => (
            <option key={r.id} value={r.id}>Room {r.room_number}</option>
          ))}
        </select>

        <select
          value={student}
          disabled={!room}
          onChange={(e) => setStudent(e.target.value)}
        >
          <option value="">Select Student</option>
          {students.map((s) => (
            <option key={s.id} value={s.id}>{s.name}</option>
          ))}
        </select>

        <select
          value={plan}
          disabled={!hostel}
          onChange={(e) => setPlan(e.target.value)}
        >
          <option value="">Select Yearly Mess Plan</option>
          {plans.map((p) => (
            <option key={p.id} value={p.id}>
              Veg ₹{p.veg_price} / Non-Veg ₹{p.nonveg_price} ({p.year})
            </option>
          ))}
        </select>

        <select value={foodType} onChange={(e) => setFoodType(e.target.value)}>
          <option value="veg">Veg</option>
          <option value="nonveg">Non-Veg</option>
        </select>

        <button onClick={assign}>Assign Student</button>
      </div>
    </div>
  );
}